import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from './global';
import 'rxjs/add/operator/map';
import * as moment from 'moment';
import { ProductsProperties } from '../model/ProductProperties';

@Injectable()

export class ProductsPropertiesService{
  //http://homestead.test/api/products/1/properties
  url:string = GLOBAL.url+"products";
  secondparameter:string = "properties?sort=+id";

  constructor( private http:HttpClient ) {}
/**
 * Obtiene 10 elementos.
 * @return listado o un error.
 */
  public get(id:number){
    let url = this.url+'/'+id+'/'+this.secondparameter;
    return this.http.get(url ).map( res => {
        return res;
    });
  }

  /**
   * Obtiene todo el listado.
   * @return listado o un error.
   */
    public getAll(id:number){
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      let url = this.url+'/'+id+'/'+this.secondparameter+'&limit=100';
      return this.http.get(url ).map( res => {
          return res;
      });
    }

/**
 * Envia un POST para almacenar información.
 * @param  prov información a enviar
 * @return      respuesta de la peticion http
 */
  public save(prov:any,id:number){
    let headers = new Headers({
      'Content-Type':'application/json'
    })
    let url = this.url+'/'+id+'/'+this.secondparameter;
    return this.http.post(url, prov)
      .map( data => {
        return data;
      });
  }

/**
 * Actualiza un elemento en la base de datos
 * @param  url  url del elemento que se actualiza.
 * @param  body ¿?
 * @return      respuesta de la peticion http
 */
  public update(id:number, body){
    let url = this.url+'/'+id+'/'+this.secondparameter;
    return this.http.put(url, body)
      .map( data => {return data;});
  }

/**
 * Elimina un registro de la base de datos
 * @param  url url del elemento que se elimina
 * @return     respuesta de la peticion http
 */
  public delete(url:string){
    return this.http.delete(url).map( response =>{
      return response;
    });

  }

/**
 * Transforma una fecha (YYYY-MM-DD 00:00:00) para ser almacenada en una BD.
 * @param  fechas fecha a transformar
 * @return        fecha con el formato (YYYY-MM-DD 00:00:00)
 */
 transformDates(fechas:Date):String{
   let fecha = moment(fechas);
   //2018-02-28 00:00:00
   return (fecha.year()+'-'+(fecha.month()+1)+'-'+fecha.date()+' 00:00:00');
 }

/**
 * Transforma un objeto a un formato JSON predefinido en el modelo.
 * @param  data Informacion a transformar.
 * @return      Objeto con el formato JSON correcto.
 */
  transformData(data:any){
    let p = new ProductsProperties(data);
    return p.getJson();
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/productProperties.service.ts